export enum MCarouselControlsType {
  Dots = 'dots',
  DotsWithOverlay = 'dotsWithOverlay',
  Bar = 'bar',
}

export type MCarouselControlsProps = {
  type?: MCarouselControlsType;
  imageOverlay?: boolean;
  totalSlides?: number;
  currentSlide?: number;
  onNext?: () => void;
  onPrev?: () => void;
  className?: string;
};
